export default {
    'en': {
        account_account: 'Account',
    },
    'de': {
        account_account: 'Konto',
    },
    'fr': {
        account_account: 'Compte',
    },
    'nl': {
        account_account: 'Account',
    },
    'el': {
        account_account: 'Λογαριασμός',
    },
}